module.exports = __webpack_public_path__ + "static/media/Screenshare.17300fbc.svg";